var $ = require('jquery');

(function($) {
  var pluginName = 'gallery';
  var leftArrow = 37;
  var rightArrow = 39;
  var defaults = {
    infiniteLoop: false,
    speed: 'slow',
    autoStart: false,
    wrapperClass: '',
    nextSelector: '.next-btn',
    prevSelector: '.previous-btn',
    activeSlide: 1,
    categoryItems: null
  };
  if ($[pluginName])
    return true;

  function Plugin($el, options) {
    if (typeof options.beforeChange !== 'function')
      delete options.beforeChange;
    if (typeof options.afterChange !== 'function')
      delete options.afterChange;
    this.$el = $($el);
    this.options = options;
    this.init();
  }
  /**
   * Initialize gallery plugin
   */
  Plugin.prototype.init = function() {
    this.dataKey = {
      CATEGORY: 'category',
      ITEM: 'item',
      INDEX: 'index',
      DIRECTION: 'animationDirection',
      KEYBOARD_ALLOWED_KEYS: 'keyboard-key'
    };
    this.dataValue = {
      NEXT: 'next',
      PREV: 'prev',
      CATEGORY_CHANGE: 'changeCategory',
      PRE_ANIMATION: 'preAnimation',
      POST_ANIMATION: 'postAnimation',
      EVENT_KEYUP: 'keyup',
      KEYBOARD_ALLOWED_KEYS: {
        NEXT: [leftArrow, rightArrow],
        PREV: [leftArrow, rightArrow]
      }
    };
    /**
     * Create wrapper element for gallery, add class attribure with default + user defined class
     * append gallery to the wrapper
     * perpend wrapper the parent container
     * add style attribute to wrapper with requried styles and calculated width & height
     */
    this.wrapper = document.createElement('div');
    this.wrapper.setAttribute('class', 'l-gallery-wrapper ' + this.options.wrapperClass);
    this.$el[0].parentNode.insertBefore(this.wrapper, this.$el[0]);
    this.wrapper.appendChild(this.$el[0]);
    this.options = $.extend(this.options, {
      mainWrapper: this.wrapper.parentNode,
      slideCount: this.$el[0].children.length || 1,
      itemTagName: this.$el[0].firstElementChild.tagName
    });
    this.mapWrapperSize();
    $(window).on('resize', this.mapWrapperSize.bind(this));
    this.bindEvents();
    return this;
  };

  /**
   * Map gallery wrapper size (width, height, positon)
   */
  Plugin.prototype.mapWrapperSize = function() {

    this.options = $.extend(this.options, {
      itemWidth: this.options.mainWrapper.clientWidth,
      itemHeight: this.options.mainWrapper.clientHeight
    });

    var width = this.options.itemWidth;
    var height = this.options.itemHeight;
    var sliderWidth = width * (this.options.slideCount * 2 + 1);
    this.wrapper.setAttribute('style',
      'width:' + width + 'px;' +
      'height:' + height + 'px;' +
      'float:none;' +
      'display:block;' +
      'text-align:center;' +
      'position:relative;' +
      'top:auto;' +
      'left:auto;' +
      'right:auto;' +
      'bottom:auto;' +
      'z-index:auto;' +
      'overflow:hidden;'
    );
    this.$el[0].setAttribute('style',
      'width:' + sliderWidth + 'px;' +
      'height:' + height + 'px;' +
      'float:none;' +
      'position:absolute;' +
      'top:0;' +
      'left:0;' +
      'right:auto;' +
      'bottom:auto;'
    );
    this.mapItems();
    this.updateCaption();
    return this;
  };
  /**
   * Map Gallery item
   */
  Plugin.prototype.mapItems = function() {
    var _self = this;
    this.$el.children().each(function(index) {
      $(this).width(_self.options.itemWidth);
      if (!$.data(this, _self.dataKey.ITEM)) {
        $(this).attr('data-' + _self.dataKey.INDEX, index + 1);
        $.data(this, _self.dataKey.ITEM, index + 1);
      }
    });
    return true;
  };
  /**
   * Bind events for gallery
   */
  Plugin.prototype.bindEvents = function() {
    var _self = this;
    var $mainWrapper = $.find(_self.options.mainWrapper);
    var $nextSelector = $mainWrapper.find(_self.options.nextSelector);
    var $prevSelector = $mainWrapper.find(_self.options.prevSelector);

    $.data($nextSelector[0], _self.dataKey.DIRECTION, _self.dataValue.NEXT);
    $.data($prevSelector[0], _self.dataKey.DIRECTION, _self.dataValue.PREV);

    $.data($nextSelector[0], _self.dataKey.KEYBOARD_ALLOWED_KEYS, _self.dataValue.KEYBOARD_ALLOWED_KEYS.NEXT);
    $.data($prevSelector[0], _self.dataKey.KEYBOARD_ALLOWED_KEYS, _self.dataValue.KEYBOARD_ALLOWED_KEYS.PREV);

    $nextSelector.on('click keyup', _self.triggerSlide.bind(_self));
    $prevSelector.on('click keyup', _self.triggerSlide.bind(_self));
    $mainWrapper.find('.t-photo-info').on('click', function(event) {
      event.preventDefault();
      $(this).toggleClass("is-collapsed").next('.t-photo-caption').slideToggle();
    });
  };
  /**
   * prevent default event of gallery navigation elements,
   * prevent animation if no or only gallery available,
   * check for next or previous gallery item request
   */
  Plugin.prototype.triggerSlide = function(event) {
    event.preventDefault();
    var _self = this;
    var $el = $(event.currentTarget);
    _self.animationDirection = $el.data(_self.dataKey.DIRECTION);
    if (event.type === _self.dataValue.EVENT_KEYUP) {
      if ($el.data(_self.dataKey.KEYBOARD_ALLOWED_KEYS).indexOf(event.keyCode) < 0)
        return true;
      _self.animationDirection = event.keyCode === leftArrow ? _self.dataValue.PREV : (event.keyCode === rightArrow ? _self.dataValue.NEXT : _self.animationDirection);
    }

    // check if no or only item is present
    if (_self.options.slideCount <= 1)
      return true;

    _self.activeSlide = _self.$el.find(_self.options.itemTagName + '[data-index="' + _self.options.activeSlide + '"]');
    _self.animateItem($el);
  };
  /**
   * Filter category items
   */
  Plugin.prototype.triggerCategory = function(category) {
    var _self = this;
    _self.categoryItems = this.$el.find(_self.options.itemTagName + '[data-category="' + category + '"]');
    if (!_self.categoryItems.length)
      return true;


    _self.activeSlide = _self.$el.find(_self.options.itemTagName + '[data-index="' + _self.options.activeSlide + '"]');
    _self.animationDirection = _self.dataValue.CATEGORY_CHANGE;
    var currentSlideIndex = _self.$el.find(_self.options.itemTagName).index(_self.activeSlide);
    var categoryItemIndex = _self.$el.find(_self.options.itemTagName).index(_self.categoryItems[0]);

    if (currentSlideIndex < categoryItemIndex) {
      _self.animationDirection = _self.dataValue.NEXT;
      _self.$el.find(_self.options.itemTagName).slice(0 , categoryItemIndex).slice(currentSlideIndex + 1).hide();
      _self.$el.css('left', '-' + (_self.options.itemWidth * currentSlideIndex) + 'px');
    } else {
      _self.animationDirection = _self.dataValue.PREV;
      _self.$el.find(_self.options.itemTagName).slice(0 , currentSlideIndex).slice(currentSlideIndex + 1).hide();
      _self.$el.css('left', '-' + (_self.options.itemWidth * (categoryItemIndex + 1)) + 'px');
    }
    _self.animateItem(null, function() {
      _self.$el.css('left', '-' + (_self.options.itemWidth * categoryItemIndex) + 'px');
      _self.$el.find(_self.options.itemTagName).show();
    });
    return true;
  };
  /**
   * Handle slide animation, set slide position based upon left/right direction
   * update image caption based upon selection
   */
  Plugin.prototype.animateItem = function($el, callback) {
    var _self = this;
    var itemToAnimate = $el ? _self.activeSlide.next(_self.options.itemTagName) : $(_self.categoryItems[0]);
    var left = '-=' + _self.options.itemWidth;

    if (_self.animationDirection === _self.dataValue.NEXT) {
      if (!_self.options.infiniteLoop && !itemToAnimate.length)
        return true;
    } else if (_self.animationDirection === _self.dataValue.PREV) {
      itemToAnimate = $el ? _self.activeSlide.prev(_self.options.itemTagName) : $(_self.categoryItems[0]);
      _self.options.infiniteLoop && (itemToAnimate = _self.$el.find('[data-index]:last-child'));
      if (!_self.options.infiniteLoop && !itemToAnimate.length) {
        _self.resetDefautlPosition();
        return true;
      }

      left = '+=' + _self.options.itemWidth;

    }

    if(itemToAnimate.find('iframe').length) {
      $(_self.options.mainWrapper).find('.t-image-count').addClass('l-display-none');
    } else {
      $(_self.options.mainWrapper).find('.t-image-count').removeClass('l-display-none');
    }
    _self.beforeChange($el, itemToAnimate);
    _self.infiniteLoop(_self.dataValue.PRE_ANIMATION);
    _self.updateCaption(itemToAnimate);
    _self.$el.animate({
      left: left
    }, _self.options.speed, function() {
      _self.infiniteLoop(_self.dataValue.POST_ANIMATION);
      _self.afterChange($el, itemToAnimate);
      if(typeof callback === "function"){
        callback();
      }
    });
  };
  /**
   * Check if inifinite loop of gallery
   */
  Plugin.prototype.infiniteLoop = function(animationFlag) {
    var _self = this;
    if (_self.options.infiniteLoop) {
      if (animationFlag === _self.dataValue.PRE_ANIMATION && _self.animationDirection === _self.dataValue.PREV) {
        _self.$el.prepend(_self.$el[0].children[_self.options.slideCount - 1]);
        _self.resetDefautlPosition(animationFlag);
      } else if (animationFlag === _self.dataValue.POST_ANIMATION && _self.animationDirection === _self.dataValue.NEXT) {
        _self.$el.append(_self.$el[0].children[0]);
        _self.resetDefautlPosition();
      } else {
        _self.resetDefautlPosition();
      }
    }
  };
  /**
   * Update caption of item
   */
  Plugin.prototype.updateCaption = function($element) {
    var _self = this;
    if (!$element)
      $element = _self.$el.find(_self.options.itemTagName + ':nth-child(' + _self.options.activeSlide + ')');
    _self.options.activeSlide = $element.data('item');
    var mainWrapper = $.find(_self.options.mainWrapper);
    if($element.data('caption')) {
      mainWrapper.find('.t-photo-description').show();
    } else {
      mainWrapper.find('.t-photo-description').hide();
    }
    mainWrapper.find('.t-image-count span:first-child').text(_self.options.activeSlide);
    mainWrapper.find('.t-photo-name').text($element.data('title'));
    mainWrapper.find('.t-photo-caption').text($element.data('caption'));
    mainWrapper.find('.t-photo-info').addClass("is-collapsed").next('.t-photo-caption').hide();
  };
  Plugin.prototype.resetDefautlPosition = function(animationFlag) {
    var left = animationFlag ? '-' + this.options.itemWidth + 'px' : 0;
    this.$el[0].style.left = left;
  };

  Plugin.prototype.beforeChange = function($element, $itemToAnimate) {
    if (this.options.beforeChange){
      this.options.beforeChange.call(this, $element, $itemToAnimate, this.animationDirection);
    }
  };
  Plugin.prototype.afterChange = function($element, $itemToAnimate) {
    if (this.options.afterChange){
      this.options.afterChange.call(this, $element, $itemToAnimate, this.animationDirection);
    }
  };
  Plugin.prototype.filterCategory = function(category) {
    this.triggerCategory(category);
  };


  /**
   * ==========================================
   *                                        ===
   * Creating jQuery plugin                 ===
   *                                        ===
   * ==========================================
   */
  $.fn[pluginName] = function(options) {

    /**
     * Check for custom options for the carousel
     * only `undefined` or `object` is allowed
     */
    if (options !== undefined && typeof options !== "object") {
      console.log('Initialize error :: options must be an Object');
      return false;
    }

    // overwrite default config with user defined options
    defaults.activeSlide = 1;

    return this.each(function() {
      var pluginOptions = $.extend({}, defaults, options);
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, pluginOptions));
      }
    });
  };
})($);